'use strict';

var React = require('react');

var SvgFinancesMinor = function SvgFinancesMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.445 3.168a1 1 0 0 1 1.11 0l6 4a1 1 0 0 1 .152 1.54l-.707.706v4.586a1.55 1.55 0 0 1-.55 3h-10.9a1.55 1.55 0 0 1-.55-3v-4.586l-.707-.707a1 1 0 0 1 .152-1.54l6-3.999Zm2.555 5.832a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Zm-3 1a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0v-3Z"
  }));
};

exports.SvgFinancesMinor = SvgFinancesMinor;
